import React from 'react';
import Store from '../../../redux/store';
import { get, getConfig } from '../../../helpers';
import { getCommuniqueformFields, submitToMarketo } from '../utilities/form-utilities';

const RequestTrialForm = React.lazy(() => import('../index' /* webpackChunkName: "request-a-trial-form" */));

function getMarketoAPIVariant(variant: string): string {
    return getConfig(`components.request-a-trial.marketoAPIVariant.${variant}`, 'Communique') as string;
}

function getCommuniqueSubmissionBody(
    data: RequestATrialState
) {
    const communiqueAPIRequest: RATCommuniqueBaseRequest = {
        company: data.Company,
        email: data.Email,
        firstName: data.FirstName,
        lastName: data.LastName,
        state: data.State ? String(data.State) : '',
        cInterestOther: data.OtherInterest,
        cInterestOtherLive: data.OtherInterest,
        complianceCountry: data.Country as string,
        gDPRConsentQuestion: String(data.HasUserConsent)
    } as RATCommuniqueBaseRequest;
    return communiqueAPIRequest;
}

function RequestTrialCommunique(props: RequestATrialFormProps) {
    const { productName = '', marketMSADataLink, dataFilePath, productVariant, variant, titleText, keyPageIdPageText, ratVariant } = props;
    const onSubmit = (
        data: RequestATrialState,
        cb: () => void,
        error: (error: string) => void
    ) => {
        const utmParameters: UTMParameters = get(Store.getState(), 'shared.utmParameters', {});
        let notapplicableText = data.InterestArea ? '' : 'Data Management Solutions';
        if (productVariant === 'solution') notapplicableText = productName;
        data.InterestArea = `${notapplicableText}`;
        data.OtherInterest = `${notapplicableText}`;
        let requestBody = getCommuniqueSubmissionBody(data);
        requestBody = {
            ...requestBody,
            utmSource: utmParameters.utmSource,
            utmMedium: utmParameters.utmMedium,
            utmCampaign: utmParameters.utmCampaign,
            utmTerm: utmParameters.utmTerm,
            utmContent: utmParameters.utmContent,
            variant: getMarketoAPIVariant(variant || '')
        };
        submitToMarketo(requestBody, cb, error);
    };
    return (
        <RequestTrialForm onSubmitForm={onSubmit} formTextFields={getCommuniqueformFields()} productVariant={productVariant} keyPageIdPageText={keyPageIdPageText} titleText={titleText} marketMSADataLink={marketMSADataLink} dataFilePath={dataFilePath} productName={productName} headerVariant={variant} ratVariant={ratVariant} />
    );
}

export default React.memo(RequestTrialCommunique);
